import * as React from "react";
import { css } from "@emotion/react";
import { useTranslation } from "react-i18next";
import { GoogleMap } from "main/javascripts/components/atoms/GoogleMap";
import { space } from "main/javascripts/styles/base/spaceStyle";
import {
  fontSize,
  lineHeight,
} from "main/javascripts/styles/base/typographyStyle";
import { accentColor } from "main/javascripts/styles/base/colorStyle";

export interface IProps {
  address: string;
  name: string;
  latitude: number;
  longitude: number;
}

export const Location: React.FC<IProps> = (
  props: IProps
): React.ReactElement => {
  const { latitude, longitude } = props;
  const { t } = useTranslation(["component"]);

  // const encodedAddress = encodeURI(address);
  // const encodedName = encodeURI(name);
  // const googleMapUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}+${encodedName}`;
  // 緯度経度で指定する場合
  const googleMapUrl = `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;
  return (
    <div>
      <GoogleMap latitude={latitude} longitude={longitude} />
      <div>
        <a
          css={linkStyle}
          href={googleMapUrl}
          target="_blank"
          rel="nofollow noreferrer"
        >
          {t("common.viewLargerMap")}
        </a>
      </div>
    </div>
  );
};

const linkStyle = css`
  padding: ${space.atom0_5x};
  margin: ${space.atom0_5x};
  font-size: ${fontSize.body};
  line-height: ${lineHeight.body2};
  color: ${accentColor.primaryColor};
  text-decoration: none;
  border-bottom: 1px solid;
  transition: color 0.3s ease;
  &:hover {
    color: ${accentColor.primaryDarkColor};
  }
`;
